import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { Spx } from '@wix/thunderbolt-becky-types'
import { getConverter } from '../../utils/convertersRegistry'
import { getStringFromConverter } from '../../utils/converterHelpers'

/** Internal Converters */
const mathOperationConverter = (styleProp: StylePropertiesTypes.MathOperation): string => {
	return `${styleProp.value}`
}

const mathValueToResolvedString = (
	prop: StylePropertiesTypes.MathFunctionValueTypes | StylePropertiesTypes.MathOperation,
	spx?: Spx
): string => {
	// Try to get converter from registry
	const converter = getConverter(prop.type)
	if (converter) {
		const result = converter(prop, spx)
		return getStringFromConverter(result)
	}

	// Fallback for unknown types
	console.warn(`No converter found for math function value type: ${prop.type}`)
	return ''
}

const mathFunctionCommonConverter = (styleProp: StylePropertiesTypes.MathFunction, spx?: Spx): string => {
	const convertedValues = styleProp.values.map((functionValue: StylePropertiesTypes.MathFunctionValueTypes) => {
		return mathValueToResolvedString(functionValue, spx)
	})
	const joinSeparator = styleProp.function === 'calc' ? ' ' : ','
	return `${styleProp.function}(${convertedValues.join(joinSeparator)})`
}

/** External Mapper */
export const mathConverterMap = {
	MathFunction: mathFunctionCommonConverter,
	Operation: mathOperationConverter,
}
